export class ChecklistOptionResponse<T> {
  id: T
  name: string
  checked: boolean

  constructor(id: T, name: string, checked: boolean) {
    this.id = id
    this.name = name
    this.checked = checked
  }
}
